import { Routes, Route, Outlet } from 'react-router-dom'
import { Layout } from './components/Layout'
import { Home } from './pages/Home'
import { Authors } from './pages/Authors'
import { NewQuote } from './pages/NewQuote'
import { Sources } from './pages/Sources'
import { QuotePage } from './pages/QuotePage'
import { QuoteEditPage } from './pages/QuoteEditPage'
import { TagsPage } from './pages/TagsPage'
import { TagDetailPage } from './pages/TagDetailPage'
import { SourceDetailPage } from './pages/SourceDetailPage'
import { AuthorDetailPage } from './pages/AuthorDetailPage'
import { Settings } from './pages/Settings'
import { ReviewCenter } from './pages/ReviewCenter'
import { AuthProvider } from './context/AuthContext'

// Das Bearbeitungscenter bringt eigene Kopfzeile und Navigation mit und
// läuft deshalb außerhalb von <Layout>.
const WithLayout = () => (
  <Layout>
    <Outlet />
  </Layout>
)

function App() {
  return (
    <AuthProvider>
      <Routes>
        <Route path="/review" element={<ReviewCenter />} />
        <Route element={<WithLayout />}>
          <Route path="/" element={<Home />} />
          <Route path="/quote/:id" element={<QuotePage />} />
          <Route path="/quotes/:id/edit" element={<QuoteEditPage />} />
          <Route path="/tags" element={<TagsPage />} />
          <Route path="/tags/:id" element={<TagDetailPage />} />
          <Route path="/authors" element={<Authors />} />
          <Route path="/authors/:id" element={<AuthorDetailPage />} />
          <Route path="/sources" element={<Sources />} />
          <Route path="/sources/:id" element={<SourceDetailPage />} />
          <Route path="/new" element={<NewQuote />} />
          <Route path="/settings" element={<Settings />} />
        </Route>
      </Routes>
    </AuthProvider>
  )
}

export default App
